import { Outlet } from "react-router-dom";
import SideBar from "../components/views/SideBar";
import HeaderName from "../components/views/HeaderName";

const AdminLayout = () => {
  return (
    <div classNameName="App">
      <div className="wrapper">
        <HeaderName />
        <SideBar />
        <Outlet />
        <footer className="main-footer">
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href="http://www.kwintechnologies.com">K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;
